/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AppLoading from "components/AppLoading/AppLoading";

export const ToolEditorLoading = () => {
  return (
    <AppLoading
      css={css`
        height: 100% !important;
        width: 100% !important;
      `}
    />
  );
};
